// Service singletons exposed on window, as the existing components expect.
// Imported first by both app entry points (Translate and Room).

import { ApiService, apiService } from '../services/api.js';
import { WebSocketService, websocketService } from '../services/websocket.js';
import { AudioService, audioService } from '../services/audio.js';
import { TTSAudioService, ttsAudioService } from '../services/tts.js';
import { authGuardService, googleAuthService } from '../services/auth/index.js';
import { configService } from '../services/config.js';
import { userAuthComponent } from '../components/user-auth.js';

window.ApiService = ApiService;
window.apiService = apiService;
window.WebSocketService = WebSocketService;
window.websocketService = websocketService;
window.AudioService = AudioService;
window.audioService = audioService;
window.TTSAudioService = TTSAudioService;
window.ttsAudioService = ttsAudioService;
window.configService = configService;
window.authGuardService = authGuardService;
window.googleAuthService = googleAuthService;
window.userAuthComponent = userAuthComponent;

// Capture the install prompt so the Install page can offer it later.
window.deferredPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    window.deferredPrompt = e;
});

export { apiService, websocketService, audioService, ttsAudioService, configService, authGuardService, googleAuthService };
